/**
 * Generic scroll tracking for lazy loading of image batches in long lists
 * @param component parent component
 */
export default function trackScrolling(component: any) {
  let scrollHeight

  return function (ev: Event) {
    const { skip, totalItemsCount, items, getItems } = component.props

    const elem: HTMLDivElement = ev.target as HTMLDivElement

    // Prevent requesting new items when it is still rendering the previous batch.
    if (scrollHeight === elem.scrollHeight) return

    if (elem.scrollTop + 1000 >= elem.scrollHeight - elem.offsetHeight) {
      if (totalItemsCount > items.length) {
        scrollHeight = elem.scrollHeight
        getItems({ skip })
      }
    }
  }
}
